import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { PostService } from '../../services/post.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  currentUserId: number | null = null;
  newPostsCount: number = 0;
  isLoadingPostsCount = false;
  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private postService: PostService,
    private router: Router
  ) {}

  ngOnInit(): void {
    const currentUser = this.authService.getCurrentUser();
    if (currentUser) {
      this.currentUserId = currentUser.id;
    }

    // Load new posts count
    this.loadNewPostsCount();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  loadNewPostsCount(): void {
    this.isLoadingPostsCount = true;
    // For now, we'll fetch the first page and count posts
    // This can be replaced with a dedicated API endpoint later
    this.postService.getFeed(1, 1)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response.success && response.data) {
            // If there's a totalCount, we can use it
            // For now, we'll show a placeholder or use totalCount if available
            // TODO: Replace with actual new posts count API when available
            this.newPostsCount = response.data.totalCount || 0;
          }
          this.isLoadingPostsCount = false;
        },
        error: (error) => {
          console.error('Error loading posts count:', error);
          this.newPostsCount = 0;
          this.isLoadingPostsCount = false;
        }
      });
  }

  navigateToFeed(): void {
    this.router.navigate(['/feed']);
  }

  navigateToFamilyTree(): void {
    if (this.currentUserId) {
      this.router.navigate(['/hierarchy', this.currentUserId]);
    }
  }

  navigateToTimeline(): void {
    if (this.currentUserId) {
      this.router.navigate(['/relative', this.currentUserId, 'timeline']);
    }
  }

  navigateToFamilyTimeline(): void {
    if (this.currentUserId) {
      this.router.navigate(['/relative', this.currentUserId, 'family-timeline']);
    }
  }

  navigateToRelationshipCalculator(): void {
    // Navigate with query param to pre-select Person1
    if (this.currentUserId) {
      this.router.navigate(['/relationship-calculator'], {
        queryParams: { person1Id: this.currentUserId, disabled: 'true' }
      });
    } else {
      this.router.navigate(['/relationship-calculator']);
    }
  }

  navigateToProfile(): void {
    this.router.navigate(['/profile']);
  }

  navigateToInviteRelative(): void {
    this.router.navigate(['/invite-relative']);
  }
}
